/* 
This file is meant to contain everything in these files but without depending on NextJS,
so we can use Vite instead:
- frontend/dashboard.scale.com/pages/_app.ts
- frontend/components/ui/App.tsx

There are more features that need to be ported here eventually.
*/
import { Theme } from '@scale/scaleui-radix';
import ScaleAITheme from 'react-scale/components/ui/theme';

// eslint-disable-next-line restrict-imports/restrict-imports
import { ThemeProvider } from '@material-ui/core/styles';
import { sAlert } from 'react-scale/components/ui/styles';
import {
  QueryClient as QueryClientV3,
  QueryClientProvider as QueryClientProviderV3,
} from 'react-query';
import { QueryClientProvider as QueryClientProviderV4 } from '@tanstack/react-query-v4';
import {
  QueryClientProvider as QueryClientProviderV5,
  QueryClient as QueryClientV5,
} from '@tanstack/react-query';
import { queryClient as queryClientV4 } from 'react-scale/corp/views/CorpProjectGroupManager/communication/apiClient';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ErrorBoundary } from 'react-error-boundary';

import ErrorFallback from './ErrorFallback';
import PrivateRoute from './PrivateRoute';
import LoginVite from './LoginVite';
import CorpIndexVite from './CorpIndexVite';

import '@fortawesome/fontawesome-svg-core/styles.css';
import 'react-table/react-table.css';
import 'graphiql/graphiql.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'react-quill/dist/quill.snow.css';
import '@react-awesome-query-builder/ui/css/styles.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import '../../dist/tailwind_globals2.css';
import '@scale/scaleui/global.css';
import '@scale/scaleui-radix/dist/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import 'jsondiffpatch/dist/formatters-styles/html.css';
import 'katex/dist/katex.min.css';
import '../../prosemirror-math.css';
import 'highlight.js/styles/atom-one-dark.css';
import 'reactflow/dist/style.css';
import 'react-scale/components/scalers/tasks/ThreadedInteraction/components/editor/table.css';
import '@react-awesome-query-builder/mui/css/styles.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas, faSortAlt } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
library.add(fas, far, faSortAlt); // FontAwesome initialization

const queryClientV3 = new QueryClientV3();
const queryClientV5 = new QueryClientV5();

export default function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Theme
        hasBackground={false}
        style={{
          minHeight: '0',
        }}
      >
        <QueryClientProviderV5 client={queryClientV5}>
          <QueryClientProviderV4 client={queryClientV4}>
            <QueryClientProviderV3 client={queryClientV3}>
              <ThemeProvider theme={ScaleAITheme}>
                <BrowserRouter basename="corp">
                  <QueryParamProvider ReactRouterRoute={Route}>
                    <Switch>
                      <Route path="/login" component={LoginVite} />
                      <PrivateRoute path="/" component={CorpIndexVite} />
                    </Switch>
                  </QueryParamProvider>
                </BrowserRouter>
              </ThemeProvider>
            </QueryClientProviderV3>
          </QueryClientProviderV4>
        </QueryClientProviderV5>
        <style jsx global>
          {sAlert}
        </style>
      </Theme>
    </ErrorBoundary>
  );
}
